import { addError, addSuccess } from '@actions/utils';
import { projectApi } from '@api/project';
import Button from '@ui/Button';
import Form from '@ui/Form';
import { InputFormField, SelectFormField } from '@ui/Form/Fields';
import { pick } from 'lodash';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { I18n } from 'react-redux-i18n';
import { useRedux } from 'use-redux';
import styles from './styles.module.scss';
import { Link } from 'react-router';
import { FilePond, registerPlugin } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';

registerPlugin(FilePondPluginFileValidateType);

const Project = props => {
  const onProcessFile = (err, file) => {
    updateProject({
      files: [file.serverId],
    });
  };
  const onRemoveFile = () => {
    updateProject({ files: [] });
  };

  const [, dispatch] = useRedux();
  const {
    params: { id },
  } = props;

  const formMethods = useForm<any>({});
  const { reset } = formMethods;

  const STATUSES = [
    { label: I18n.t('gui.projects.private'), value: 'private' },
    { label: I18n.t('gui.projects.public'), value: 'public' },
  ];

  useEffect(() => {
    reset();
    id &&
      projectApi.getProject(id).then(res => {
        reset(pick(res, ['name', 'description', 'status']));
      });
  }, [id, reset]);

  const updateProject = async (options: any) => {
    if (!id) return;

    try {
      await projectApi.updateProject(id, options);
      dispatch(addSuccess());
    } catch (error) {
      dispatch(addError(error));
    }
  };

  const onSubmit = async (values: any) => {
    updateProject(values);
  };

  return (
    <div className="container">
      <div className={styles.header}>
        <h1>{I18n.t('gui.projects.change')}</h1>
      </div>

      <Form formMethods={formMethods} onSubmit={onSubmit}>
        <InputFormField name="name" label={I18n.t('main.title')} />
        <InputFormField name="description" label={I18n.t('main.description')} />
        <SelectFormField
          defaultValue="private"
          options={STATUSES}
          name="status"
          label="Статус"
        />

        <div>
          <FilePond
            credits={false}
            onremovefile={onRemoveFile}
            onprocessfile={onProcessFile}
            allowMultiple={false}
            server={'/project/files'}
            maxFiles={1}
            name="files"
            acceptedFileTypes={['image/*']}
            labelIdle={I18n.t('gui.projects.dragFile')}
          />
        </div>

        <div className={styles.footer}>
          <Button type="submit" color="green">
            {I18n.t('main.buttons.save')}
          </Button>
          <Link to="/i/projects">
            <Button color="grey" style={{ width: 150 }}>
              {I18n.t('gui.projects.backToList')}
            </Button>
          </Link>
        </div>
      </Form>
    </div>
  );
};

export default Project;
